module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNVQJ"))).then(() => parcelRequire('dJXJK'));